import styled from "@emotion/styled"
import { Button } from "@mui/material"

const StyledCategoriesDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.down("md")} {
    border-bottom: 1px solid #d1d5db;
  }
`

const StyledCategoryItem = styled(Button)<{ isActive?: boolean }>`
  height: 48px;
  width: auto;
  padding: 16px;
  font-size: 20px !important;
  font-weight: 400;
  border: 1px solid #d1d5db;
  background-color: ${(p) => (p.isActive ? "#008761" : "white")};
  color: ${(p) => (p.isActive ? "white" : "#051711")};
  font-weight: ${(p) => (p.isActive ? 700 : 400)};
`

type Props = {
  categories: string[]
  selectedCategories: string[]
  handleAllCategories: () => void
  handleCategoryClick: (category: string) => void
}

const JobCategories = ({
  categories,
  selectedCategories,
  handleAllCategories,
  handleCategoryClick,
}: Props) => {
  return (
    <StyledCategoriesDiv>
      <StyledCategoryItem
        key={"all category"}
        isActive={selectedCategories.length === 0}
        onClick={handleAllCategories}
        role="checkbox"
        aria-checked={selectedCategories.length === 0}
      >
        כל המשרות
      </StyledCategoryItem>
      {categories &&
        categories.map((category: string, index: number) => {
          return (
            <StyledCategoryItem
              key={index}
              isActive={selectedCategories.includes(category)}
              onClick={() => handleCategoryClick(category)}
              role="checkbox"
              aria-checked={selectedCategories.includes(category)}
            >
              {category}
            </StyledCategoryItem>
          )
        })}
    </StyledCategoriesDiv>
  )
}

export default JobCategories
